'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _copyProps = require('../utils/copy-props');

var _copyProps2 = _interopRequireDefault(_copyProps);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

var _VstTableHeader = require('./VstTableHeader');

var _VstTableHeader2 = _interopRequireDefault(_VstTableHeader);

var _VstTableBody = require('./VstTableBody');

var _VstTableBody2 = _interopRequireDefault(_VstTableBody);

var _VstTableRow = require('./VstTableRow');

var _VstTableRow2 = _interopRequireDefault(_VstTableRow);

var _VstTableCell = require('./VstTableCell');

var _VstTableCell2 = _interopRequireDefault(_VstTableCell);

var _glamor = require('glamor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Data passed in should include props for 'headers' and 'items'
  The keys for 'items' should match the keys for headers

  By default items will be sorted on their string value passed in
  For something different (such as dates or prices before appending currencies),
  add an additional key prepended with '_sort_'.
  For example, for {price="$1.00"} you'd add {_sort_price:1.00}

*/
var VstTable = function (_VstComponent) {
  _inherits(VstTable, _VstComponent);

  // TODO: Handle when original props change
  function VstTable() {
    _classCallCheck(this, VstTable);

    var _this = _possibleConstructorReturn(this, (VstTable.__proto__ || Object.getPrototypeOf(VstTable)).call(this));

    _this._toggleSortOrder = _this._toggleSortOrder.bind(_this);
    _this.state = {
      sortOrder: 1,
      sortedHeaderIndex: null
    };
    return _this;
  }

  _createClass(VstTable, [{
    key: '_toggleSortOrder',
    value: function _toggleSortOrder(toggledHeaderIndex) {
      var headerIndex = parseInt(toggledHeaderIndex, 10);
      if (this.state.sortOrder === -1 || this.state.sortedHeaderIndex !== headerIndex) {
        this.setState({
          sortOrder: 1,
          sortedHeaderIndex: headerIndex
        });
      } else {
        this.setState({
          sortOrder: -1,
          sortedHeaderIndex: headerIndex
        });
      }
    }
  }, {
    key: '_getCSS',
    value: function _getCSS() {
      return {
        '& tbody tr:hover td': {
          background: this._theme(1)
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var children = _react2.default.Children.map(this.props.children, function (child) {
        if (child.type.displayName === 'VstTableHeader') {
          return _react2.default.cloneElement(child, { onClick: _this2._toggleSortOrder });
        } else if (child.type.displayName === 'VstTableBody') {
          return _react2.default.cloneElement(child, {
            sortOrder: _this2.state.sortOrder,
            sortIndex: _this2.state.sortedHeaderIndex
          });
        }
        return child;
      });

      var rule = (0, _glamor.css)(this._getCSS());

      return _react2.default.createElement(
        'div',
        { className: 'vst-table-wrapper', style: { height: this.props.height } },
        _react2.default.createElement(
          'div',
          { className: 'vst-table-inner-wrapper' },
          _react2.default.createElement(
            'table',
            _extends({ className: 'vst-table ' + rule }, (0, _copyProps2.default)(this.props, ['items'])),
            children
          )
        )
      );
    }
  }]);

  return VstTable;
}(_VstComponent3.default);

VstTable.Header = _VstTableHeader2.default;
VstTable.Header.displayName = 'VstTableHeader';
VstTable.Body = _VstTableBody2.default;
VstTable.Body.displayName = 'VstTableBody';
VstTable.Row = _VstTableRow2.default;
VstTable.Cell = _VstTableCell2.default;

exports.default = VstTable;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstTable.js
 **/